export const ISSUES_FOR_CANVAS_REQUEST = "ISSUES_FOR_CANVAS_REQUEST";
export const ISSUES_FOR_CANVAS_SUCCESS = "ISSUES_FOR_CANVAS_SUCCESS";
export const ISSUES_FOR_CANVAS_FAILED = "ISSUES_FOR_CANVAS_FAILED";